import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_ACCESS_NETWORK_ROLLOUT_INLCM_3 = {
  title: "With the polygon tool, easily \ndefine the chosen area for \ndesign.",
  subtitle: "Access Network Rollout",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_318"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_316"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_03_map_1.png",
          imageStyle: { position: "absolute", bottom: "348px", right: "103px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_03_map_2.png",
          imageStyle: { position: "absolute", bottom: "260px", right: "96px" },
        },
      ]}
      pageNumber={"ENG_317"}
    />
  ),
};
